import { createReducer } from "@reduxjs/toolkit";
import type { ProcessingState } from "@redux/state/shared-types";
import { approveBatchPayment, resetApproveBatchPayment } from "./approve-batch-payment";

const initialState: ProcessingState = {
  processing: "idle",
};

export const approveBatchPaymentReducer = createReducer<ProcessingState>(initialState, builder => {
  builder.addCase(approveBatchPayment.fulfilled, state => {
    return {
      ...state,
      processing: "success",
    };
  });
  builder.addCase(approveBatchPayment.pending, state => {
    return {
      ...state,
      processing: "pending",
    };
  });
  builder.addCase(approveBatchPayment.rejected, state => {
    return {
      ...state,
      processing: "failed",
    };
  });
  builder.addCase(resetApproveBatchPayment, () => {
    return initialState;
  });
});
